import Logo from "../assets/logo.png";
import "bootstrap/dist/css/bootstrap.min.css";

function Footer() {

    return (
        <div className="App" style={{ paddingHorizontal: 25 }}>
            <div>
                <footer className="bg-dark text-light py-3" style={{ marginTop: "1rem" }}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-2">
                                <h5 style={{ color: "#FEBC11" }}>Contact Info</h5>
                                <p>Kennesaw Campus 1000 Chastain Road Kennesaw, GA 30144.</p>
                                <p>
                                    Marietta Campus 1100 South Marietta PkwyMarietta, GA 30060
                                </p>
                                <p>Phone 470-KSU-INFO (470-578-4636)</p>
                            </div>
                            <div className="col-md-2">
                                <h5 style={{ color: "#FEBC11" }}>Resources For</h5>
                                <p>Current Students</p>
                                <p> Online Only Students</p>
                                <p>Faculty & Staff</p>
                                <p> Family Alumni & Friends Community</p>
                            </div>
                            <div className="col-md-2">
                                <h5 style={{ color: "#FEBC11" }}>Related Links</h5>
                                <p>Libraries </p>
                                <p>Housing </p>
                                <p>Financial Aid </p>
                                <p>Degrees, Majors & Programs </p>
                                <p>Register </p>
                                <p>job oppurtunity</p>
                            </div>
                            <div className="col-md-2 pt-5 ">
                                <p>Campus.</p>
                                <p>Global Education</p>
                                <p>Diverse & Inclusive Excellence</p>
                                <p>Sustainability</p>
                                <p>Accessbility</p>
                            </div>
                            <div className="col-md-2 pt-5 px-4">
                                <p style={{ fontFamily: "bold" }}>kennesaw.edu/info</p>
                                <div
                                    style={{
                                        height: 73,
                                        width: "100%",
                                        backgroundColor: "#202020",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <img src={Logo} alt="" style={{ height: 73, width: 301 }} />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <p>
                                    &copy; 2023 Kennesaw State University. All Rights Reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}

export default Footer;
